import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import StoreApplicationState, { getStoreApplicationState } from "@store/Store/StoreApplicationState";

const storage = {
    isHideAllPricesModeOn: "isHideAllPricesModeOn",
};

export const getHideAllPricesModeOn = (state: ApplicationState | StoreApplicationState) => {
    const _state = getStoreApplicationState(state);

    const storedValue =
        typeof localStorage === "undefined" ? false : localStorage.getItem(storage.isHideAllPricesModeOn) === "true";

    return _state.store.data.hideAllPricesMode.isHideAllPricesModeOn || storedValue;
};

export const setHideAllPricesModeOn = (value: boolean) => {
    return localStorage.setItem(storage.isHideAllPricesModeOn, value.toString());
};
